// src/components/GalleryCard.jsx
import useTranslations from "@/i18n/useTranslations";
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import ArtworkImage from "@/shared-components/cards/components/ArtworkImage";
import UserProfileImage from "@/shared-components/cards/components/UserProfileImage";
import Text from "@/shared-components/text/components/Text";

import "./styles/GallerySliderCard.css";

export default function GallerySliderCard({ user, onVisit }) {
  const tHome = useTranslations('common.shared.home');
  const coverImage =
    user.coverImage ||
    user.cover_image ||
    user.gallery_cover_image?.image_id ||
    null;
  const avatarImage =
    user.profilePic ||
    user.profile_pic ||
    user.user_image?.image_id ||
    null;
  const aspectRatio =
    user.coverAspectRatio ||
    user.cover_aspect_ratio ||
    user.coverAspect ||
    user.gallery_cover_image?.image_original_data?.aspect_ratio ||
    user.aspectRatio ||
    3 / 2;

  return (
    <div className="gallery-card__container">
      <div className="gallery-card__image-wrapper">
        {/* Top-left gallery avatar overlay */}
        <div className="gallery-card__avatar">
          <UserProfileImage
            image={avatarImage}
            typeOfProfile="gallery"
            className="gallery-card__avatar-image"
          />
        </div>
        {coverImage || avatarImage ? (
          <ArtworkImage
            image={coverImage || avatarImage}
            imageClassName="gallery-card__image"
            imageTemplateClassName="gallery-card__image"
            style={{ aspectRatio }}
          />
        ) : (
          <div className="gallery-card__no-image" aria-hidden="true" />
        )}
      </div>
      <div className="gallery-card__info-row">
        <div className="gallery-card__info-left">
          <Text className="gallery-card__name dots-on-overflow font-size-medium">
            {user.name}
          </Text>
          <Text className="gallery-card__subtitle dots-on-overflow font-size-medium">
            {user.country ?? "Unknown location"}
            {user.city ?? "unknown city"}
          </Text>
        </div>
        <ContinueButton
          className="gallery-card__button"
          onClick={onVisit}
        >
          <span className="gallery-card__button-text--desktop">
            {tHome('visit_profile')}
          </span>
          <span className="gallery-card__button-text--mobile">
            Visit
          </span>
        </ContinueButton>
      </div>
    </div>
  );
}
